const API_URLS = process.env.REACT_APP_API_URLS.split(',');
let currentZone = localStorage.getItem('zone') || API_URLS[0]; // Set to US AZ by default.

export function getAllZones() {
  return API_URLS;
}

export function getCurrentZone() {
  return currentZone;
}

export function setCurrentZone(zone) {
  localStorage.setItem('zone', zone);
  currentZone = zone;
}